export default "__VITE_ASSET__CLuxOB_m__"